/**
 * Default values for AutomationV2 nodes
 * Centralized constants to avoid magic numbers and ease future changes
 */

export const DEFAULT_ACTIONS = {
  RESOURCE_ID: null,
  DEFAULT_EMAIL_TEMPLATE_ID: null,
} as const;
